import classNames from 'classnames';
import { motion } from 'framer-motion';
import GiftIcon from '~/assets/svgs/gift.svg';
import TicketDiscount from '~/assets/svgs/ticket-discount.svg';

const Gift = ({ isActive, discount }: { isActive: boolean; discount: string }) => {
    const isDiscountNumber =
        typeof discount === 'string' ? !Number.isNaN(Number(discount.replace('%', '').replace('$', ''))) : false;
    return (
        <motion.div
            className={classNames('gift-icon', { active: isActive })}
            animate={isActive ? { y: [0, -4, 0], rotate: [0, 6, -6, 0] } : {}}
            transition={{
                y: {
                    duration: 1
                },
                rotate: {
                    duration: 0.5
                }
            }}
        >
            {isDiscountNumber ? (
                <TicketDiscount
                    className={classNames('w-4', {
                        'fill-[--primary]': !isActive,
                        'fill-[white]': isActive
                    })}
                />
            ) : (
                <GiftIcon
                    className={classNames('w-4', {
                        'fill-[--primary]': !isActive,
                        'fill-[white]': isActive
                    })}
                />
            )}
        </motion.div>
    );
};

export default Gift;
